<div class="ticket-wrapper">
  <div class="sidenav-body-content">
    <app-support-ticket></app-support-ticket>
  </div>
</div>
